export const transformResponseReasonSummary = summary => {
  return {
    display: summary.display,
    base_return_reason: summary.base_return_reason,
    position: summary.position,
    count: summary.count,
    refund_count: summary.refund_count,
    exchange_count: summary.exchange_count,
    percentage: summary.percentage,
    refund_percentage: summary.refund_percentage,
    exchange_percentage: summary.exchange_percentage,
    reason_percentage: summary.reason_percentage,
  }
}
